<template>
<div>
    <header>
        <span>员工分析</span>
    </header>
    <div class="staff-head">
        <el-button :type="headBtnStatus=='byDay' ? 'primary':''" @click="changeHeadBtnStatus('byDay')">按日</el-button>
        <el-button :type="headBtnStatus=='byMonth' ? 'primary':''" @click="changeHeadBtnStatus('byMonth')" class="common-btn">按月</el-button>
        <span class="writtenTime">签单时间：</span>
        <el-date-picker v-model="writtenValue" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="writtenOptions"></el-date-picker>
        <el-tree :data="companyData" show-checkbox node-key="id" :props="defaultProps"></el-tree>
    </div>
    <div class="staff-chart">
        <div class="chart-title">
            <el-button :type="chartStatus=='orderQuantity'? 'primary': ''" @click="changechartStatus('orderQuantity')">总订单数</el-button>
            <el-button :type="chartStatus=='totalSales'? 'primary': ''" @click="changechartStatus('totalSales')" class="common-btn">总销售额</el-button>
        </div>
        <div class="chart-content">
            <div class="chart-left">
                <!-- 订单总数 -->
                <el-card shadow="hover" v-if="chartStatus=='orderQuantity'">
                    <schart ref="line" class="schart" canvasId="canvas" :options="orderQuantity"></schart>
                </el-card>
                <!-- 总销售额 -->
                <el-card shadow="hover" v-if="chartStatus=='totalSales'">
                    <schart ref="line" class="schart" canvasId="canvas" :options="totalSales"></schart>
                </el-card>
            </div>
            <div class="chart-right">
                <el-table :data="rankingTop10" style="width: 100%">
                    <el-table-column prop="date" label="排名"></el-table-column>
                    <el-table-column prop="name" label="员工"></el-table-column>
                    <el-table-column prop="address" label="销售额"></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="staff-botttom">
            <div class="table-title">
                <el-button :type="financeDetail=='person'? 'primary': ''" @click="changefinanceDetail('person')">个人</el-button>
                <el-button :type="financeDetail=='group'? 'primary': ''" @click="changefinanceDetail('group')" class="common-btn">团队</el-button>
                <el-button :type="financeDetail=='company'? 'primary': ''" @click="changefinanceDetail('company')" class="common-btn">公司</el-button>
                <el-select v-model="uploadValue" class="uploadReport" placeholder="导出报表">
                    <el-option v-for="item in uploadReport" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <!-- 个人 -->
            <div class="table-person" v-if="financeDetail == 'person'">
                <el-table :data="rankingTop10" height="250" style="width: 100%">
                    <el-table-column prop="date" fixed label="排名1"></el-table-column>
                    <el-table-column prop="name" label="员工"></el-table-column>
                    <el-table-column prop="address" label="订单数"></el-table-column>
                    <el-table-column prop="address" label="订单金额"></el-table-column>
                    <el-table-column prop="address" label="实收金额"></el-table-column>
                </el-table>
            </div>
            <!-- 团队 -->
            <div class="table-group" v-if="financeDetail == 'group'">
                <el-table :data="rankingTop10" height="250" style="width: 100%">
                    <el-table-column prop="date" fixed label="排名2"></el-table-column>
                    <el-table-column prop="name" label="员工"></el-table-column>
                    <el-table-column prop="address" label="订单数"></el-table-column>
                    <el-table-column prop="address" label="订单金额"></el-table-column>
                    <el-table-column prop="address" label="实收金额"></el-table-column>
                </el-table>
            </div>
            <!-- 公司 -->
            <div class="table-company" v-if="financeDetail == 'company'">
                <el-table :data="rankingTop10" height="250" style="width: 100%">
                    <el-table-column prop="date" fixed label="排名3"></el-table-column>
                    <el-table-column prop="name" label="员工"></el-table-column>
                    <el-table-column prop="address" label="订单数"></el-table-column>
                    <el-table-column prop="address" label="订单金额"></el-table-column>
                    <el-table-column prop="address" label="实收金额"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Schart from 'vue-schart';
export default {
    data() {
        return {
            headBtnStatus: 'byDay',
            chartStatus: 'orderQuantity',
            financeDetail: 'person',
            uploadValue: '',
            forward: false, //详情
            //全公司
            companyData: [{
                id: 1,
                label: '全公司',
                children: [{
                    id: 4,
                    label: '二级 1-1',
                    children: [{
                            id: 9,
                            label: '三级 1-1-1'
                        },
                        {
                            id: 10,
                            label: '三级 1-1-2'
                        }
                    ]
                }]
            }],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            writtenOptions: {
                shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            writtenValue: '',
            // 订单总数
            orderQuantity: {
                type: 'bar',
                title: {
                    // text: '新增客资趋势'
                },
                labels: ['01', '02', '03', '04', '05', '01', '02', '03', '04', '05'],
                datasets: [{
                    label: '总订单数',
                    data: [234, 278, 270, 190, 230, 234, 278, 270, 190, 230]
                }]
            },
            //总销售额
            totalSales: {
                type: 'line',
                title: {
                    // text: '新增客资趋势'
                },
                labels: ['01', '02', '03', '04', '05', '01', '02', '03', '04', '05'],
                datasets: [{
                    label: '总销售额',
                    data: [234, 278, 270, 190, 230, 100, 200, 300, 400, 500]
                }]
            },
            //排名
            rankingTop10: [{
                    date: '1',
                    name: '王小虎',
                    address: '1000'
                },
                {
                    date: '2',
                    name: '王小虎',
                    address: '2000'
                },
                {
                    date: '3',
                    name: '王小虎',
                    address: '3000'
                },
                {
                    date: '4',
                    name: '王小虎',
                    address: '4000'
                },
                {
                    date: '1',
                    name: '王小虎',
                    address: '1000'
                },
                {
                    date: '2',
                    name: '王小虎',
                    address: '2000'
                },
                {
                    date: '3',
                    name: '王小虎',
                    address: '3000'
                },
                {
                    date: '4',
                    name: '王小虎',
                    address: '4000'
                },
                {
                    date: '3',
                    name: '王小虎',
                    address: '3000'
                },
                {
                    date: '4',
                    name: '王小虎',
                    address: '4000'
                }
            ],
            //下载报表
            uploadReport: [{
                    value: '选项1',
                    value: '1',
                    label: '个人报表'
                },
                {
                    value: '2',
                    label: '团队报表'
                },
                {
                    value: '3',
                    label: '公司报表'
                }
            ]
        };
    },
    components: {
        Schart
    },
    methods: {
        // 改变订单销售
        changeHeadBtnStatus(status) {
            this.headBtnStatus = status;
        },
        // 改变图表
        changechartStatus(status) {
            this.chartStatus = status;
        },
        // 个人、团队、公司报表详情
        changefinanceDetail(status) {
            this.financeDetail = status;
        }
    }
};
</script>

<style scoped>
.schart {
    width: 100%;
    height: 380px;
}

header {
    padding: 20px;
    margin-top: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.staff-head {
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: relative;
}

.staff-head button {
    height: 32px;
}

.common-btn {
    margin: 0;
}

.writtenTime {
    margin-left: 20px;
    font-size: 13px;
}

.staff-head .el-tree {
    width: 15%;
    border: 1px solid #ccc;
    margin-left: 3px;
    border-radius: 3px;
    position: absolute;
    left: 575px;
    top: 22px;
}

.staff-chart {
    padding: 20px;
}

.chart-left {
    width: 60%;
    height: auto;
    padding-top: 20px;
}

.chart-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.chart-right {
    width: 38%;
    height: auto;
    padding-top: 20px;
}

.table-title {
    padding: 20px;
}

.uploadReport {
    float: right;
}
</style>
